import { SearchField } from "@heroui/react";

/** The search field above a table. Labelled by its placeholder, so the field has no visible label. */
export function SearchBox({
  value,
  onChange,
  placeholder,
  className = "w-full max-w-xs",
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  className?: string;
}) {
  return (
    <SearchField
      aria-label={placeholder}
      className={`min-w-0 ${className}`}
      value={value}
      variant="secondary"
      onChange={onChange}
    >
      <SearchField.Group>
        <SearchField.SearchIcon />
        <SearchField.Input className="min-w-0" placeholder={placeholder} />
        <SearchField.ClearButton />
      </SearchField.Group>
    </SearchField>
  );
}
